module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "拒绝工单"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "rejectWoForm",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "model": _vm.formData,
      "rules": _vm.ruleWo
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "拒绝理由",
      "prop": "reason"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.reason),
      callback: function($$v) {
        _vm.$set(_vm.formData, "reason", $$v)
      },
      expression: "formData.reason"
    }
  }, _vm._l((_vm.$constant.woReason), function(item) {
    return _c('Option', {
      key: item.text,
      attrs: {
        "value": item.text
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingReject
    },
    on: {
      "click": _vm.reject
    }
  }, [_vm._v("驳回")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11168bb3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/modal/RejectWoModal.vue
// module id = 1624
// module chunks = 8